import { SystemIntelligenceView } from '@/components/systems/SystemIntelligenceView'
import { onePortalPage } from '@/lib/one-portal-data'

/** One Portal's drill-down — the dealer-facing front door onto a submission. */
export function OnePortalSalesSubmission() {
  return <SystemIntelligenceView {...onePortalPage} />
}
